import React from 'react';
import Icon from '../AppIcon';

const AdminQueueIndicator = ({ queueCount = 0, estimatedTime = 0 }) => {
  if (queueCount === 0) return null;

  const formatTime = (minutes) => {
    if (minutes < 60) return `${minutes}m`;
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    return mins > 0 ? `${hours}h ${mins}m` : `${hours}h`;
  };

  return (
    <div className="admin-queue-indicator">
      <Icon name="Clock" size={16} color="var(--color-primary)" />
      <span className="admin-queue-count">{queueCount}</span>
      <span className="text-muted-foreground">in queue</span>
      {estimatedTime > 0 && (
        <>
          <span className="text-muted-foreground">•</span>
          <span className="text-muted-foreground">{formatTime(estimatedTime)} est.</span>
        </>
      )}
    </div>
  );
};

export default AdminQueueIndicator;